import actionCreatorFactory from 'typescript-fsa';
import { AgencyInfo, SelectedStoresArray, StoreAndAgencyInfo } from '../reducers/StoreSelectorReducer';
import { filterKeyState, filterConditionState } from '../reducers/CurrentFilterReducer';
import { customCountListState } from '../reducers/CustomCountListReducer';
import { MailTopState } from '../reducers/MailTopReducer';
import { MailDetailResultState } from '../reducers/MailDetailResultReducer';
import { negotiationCountState } from '../reducers/NegotiationCountReducer';
import { SearchConditionState } from '../reducers/SearchConditionReducer';
import { FilterConditionLinkedDataState } from '../reducers/FilterLinkedDataReducer';
import { responseType } from '../../utils/TableCells';
import { SearchResultState } from '../reducers/SearchResultReducer';
import { RefreshState } from '../reducers/RefreshReducer';
import { CommonResult } from '../../external/Common';
import { LoadingType } from '../reducers/LoadingStatusReducer';
import { SearchCategoryState } from '../reducers/SearchCategoryReducer';
import { ErrorParameter, SorryMessageState } from '../reducers/SorryMessageReducer';
import { MailTemplateState } from '../reducers/MailTemplateReducer';
import { ApplyStaffState } from '../reducers/ApplyStaffReducer';
import { MailCreateState } from '../reducers/MailCreateReducer';
import { MailSaveState } from '../reducers/MailSaveReducer';
import { MailDeleteState } from '../reducers/MailDeleteReducer';
import { MailTemplateApplyState } from '../reducers/MailTemplateApplyReducer';
import { MailTemplateDetailState } from '../reducers/MailTemplateDetailReducer';
import { MailAddressSelectState } from '../reducers/MailAddressSelectReducer';
import { MailDraftState } from '../reducers/MailDraftReducer';
import { MailStopState } from '../reducers/MailStopReducer';
import { MailStopDoneState } from '../reducers/MailStopDoneReducer';
import { MasterInfoState } from '../reducers/MasterInfoReducer';
import { MessageDisplayMethodInfo } from '../../external/MessageDisplayMethodListApi';
import { CommodityCategoryContractInfo, SearchBranch } from '../../external/AggregationApi';
import { searchBranchStatusState } from '../reducers/SearchBranchStatusReducer';
import { StoreInfo } from '../../external/StoresApi';
import { MailDeliveryStopState } from '../reducers/MailDeliveryStopReducer';
import { AgencyDetailInfo } from '../../external/AgencyDetailApi';
import { DevConsoleConfig } from '../reducers/DevConsoleReducer';
import { VisitReservationStoreInfo } from '../reducers/VisitReservationInfoReducer';
import { VisitReservationInfoState, VisitReservationListInfo, VisitReservationSummaryInfo } from '../reducers/VisitReservationInfoReducer';
import { GetVisitSummaryApiRequest } from '../../external/VisitApi';
import { CustomerInfoAllState } from '../reducers/CustomerInfoAllReducer';
import { ModalConfirmState } from '../reducers/ModalReducer';
import { FilterItem } from '../reducers/StoreFilterReducer';
import { CooperationInfoList, Summary } from '../../external/LinkedDataApi';
import { VisitReservationBasicInfo } from '../reducers/HearingInfoReducer';
import { HearingInfo } from '../../external/HearingInfoApi';

const actionCreator = actionCreatorFactory();

export const actions = {
  updateCurrentFilter: actionCreator<filterKeyState>('UPDATE_CURRENT_FILTER'),
  clearFilter: actionCreator<void>('CLEAR_CURRENT_FILTER'),
  fetchCustomCountList: actionCreator<customCountListState>('FETCH_CUSTOM_COUNT_LIST'),
  fetchNegotiationCount: actionCreator<negotiationCountState>('FETCH_NEGOTIATION_COUNT'),
  fetchMailTop: actionCreator<MailTopState>('FETCH_MAIL_TOP'),
  fetchMailDetail: actionCreator<MailDetailResultState>('FETCH_MAIL_DETAIL_RESULT'),
  fetchMailTemplate: actionCreator<MailTemplateState>('FETCH_MAIL_TEMPLATE'),
  fetchMailTemplateDetail: actionCreator<MailTemplateDetailState>('FETCH_MAIL_TEMPLATE_DETAIL'),
  fetchApplyStaff: actionCreator<ApplyStaffState>('FETCH_APPLY_STAFF'),
  fetchMailTempMstList: actionCreator<MailCreateState>('FETCH_MAIL_TEMP_MST_LIST'),
  applyMailTemplate: actionCreator<MailTemplateApplyState>('APPLY_MAIL_TEMPLATE'),
  saveMailDraft: actionCreator<MailSaveState>('SAVE_MAIL_DRAFT'),
  deleteMailDraft: actionCreator<MailDeleteState>('DELETE_MAIL_DRAFT'),
  fetchMailAddressSelect: actionCreator<MailAddressSelectState>('FETCH_MAIL_ADDRESS_SELECT'),
  fetchMailDraft: actionCreator<MailDraftState>('FETCH_MAIL_DRAFT'),
  fetchMailStop: actionCreator<MailStopState>('FETCH_MAIL_STOP'),
  fetchMailDeliveryStop: actionCreator<MailDeliveryStopState>('FETCH_MAIL_DELIVERY_STOP'),
  fetchMailStopDone: actionCreator<MailStopDoneState>('FETCH_MAIL_STOP_DONE'),
  updateSearchResult: actionCreator<SearchResultState>('UPDATE_SEARCH_RESULT'),
  updateSearchCondition: actionCreator<SearchConditionState>('UPDATE_SEARCH_CONDITION'),
  filterLinkedData: {
    updateFilterCondition: actionCreator<FilterConditionLinkedDataState>('FILTER_LINKED_DATA_UPDATE_FILTER_CONDITION'),
    updateSortInfo: actionCreator<string>('FILTER_LINKED_DATA_UPDATE_SORT_INFO'),
    updateCurrentPage: actionCreator<number>('FILTER_LINKED_DATA_UPDATE_CURRENT_PAGE'),
    updateScrollInfo: actionCreator<number>('FILTER_LINKED_DATA_UPDATE_SCROLL_INFO'),
    updateApiIndexValue: actionCreator<number>('FILTER_LINKED_DATA_UPDATE_API_UPDATE_INDEX_VALUE'),
  },
  linkedDataResult: {
    updateTotalRecord: actionCreator<number>('LINKED_DATA_RESULT_UPDATE_TOTAL_RECORD'),
    updateSummaryInfo: actionCreator<Summary>('LINKED_DATA_RESULT_UPDATE_SUMMARY_INFO'),
    updateCooperationInfoList: actionCreator<CooperationInfoList[]>('LINKED_DATA_RESULT_UPDATE_COOPERATION_INFO_LIST'),
  },
  hearingInfo: {
    loadingModal: actionCreator<boolean>('HEARING_INFO_LOADING_MODAL'),
    updateDataOpenModal: actionCreator<VisitReservationBasicInfo>('HEARING_INFO_UPDATE_DATA_OPEN_MODAL'),
    resetHearingInfo: actionCreator<void>('HEARING_INFO_RESET_HEARING_INFO'),
    updateHearingInfoList: actionCreator<HearingInfo[]>('HEARING_INFO_UPDATE_HEARING_INFO_LIST'),
  },
  locationHistory: {
    resetData: actionCreator<void>('LOCATION_HISTORY_RESET_DATA'),
    updatePathName: actionCreator<string>('LOCATION_HISTORY_UPDATE_PATH_NAME'),
  },
  storeSelector: {
    initialize: {
      store: actionCreator<StoreInfo[]>('INITIALIZE_WITH_STORE'),
      agency: actionCreator<AgencyInfo[]>('INITIALIZE_WITH_AGENCY'),
      agencyDetail: actionCreator<AgencyDetailInfo>('INITIALIZE_WITH_AGENCY_DETAIL'),
    },
    toggleStore: actionCreator<StoreAndAgencyInfo>('TOGGLE_STORE'),
    updateSelectedStores: actionCreator<SelectedStoresArray>('UPDATE_TARGET_STORE'),
    updateLocalStores: actionCreator<SelectedStoresArray>('UPDATE_TARGET_LOCAL_STORE'),
    toggleModal: actionCreator<void>('TOGGLE_STORE_SELECTOR_MODAL'),
    clearSelectedStores: actionCreator<void>('CLEAR_SELECTED_STORES'),
    selectAllStores: actionCreator<void>('SELECT_ALL_STORES'),
    selectOnlyStoresInCharge: actionCreator<void>('SELECT_ONLY_STORES_IN_CHARGE'),
  },
  updateNegotiation: {
    result: actionCreator<responseType>('UPDATE_NEGOTIATION_RESULT'),
    period: actionCreator<responseType>('UPDATE_NEGOTIATION_PERIOD'),
    pending: actionCreator<responseType>('UPDATE_NEGOTIATION_PENDING'),
    pendingHeaderDisp: actionCreator<string>('UPDATE_NEGOTIATION_PENDING_HEADER_DISP'),
    action: actionCreator<responseType>('UPDATE_NEGOTIATION_ACTION'),
    prob: actionCreator<responseType>('UPDATE_NEGOTIATION_PROB'),
  },
  updateSearchBranch: {
    result: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_RESULT'),
    period: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PERIOD'),
    pending: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PENDING'),
    action: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_ACTION'),
    prob: actionCreator<{ [key: string]: SearchBranch }>('UPDATE_SEARCH_BRANCH_PROB'),
    status: actionCreator<searchBranchStatusState>('UPDATE_SEARCH_BRANCH_STATUS'),
    commodityCategoryContract: actionCreator<CommodityCategoryContractInfo>('UPDATE_SEARCH_BRANCH_COMMODITY_CATEGORY_CONTRACT'),
  },
  updateRefresh: actionCreator<RefreshState>('UPDATE_REFRESH'),
  updateSearchCategory: actionCreator<SearchCategoryState>('UPDATE_SEARCH_CATEGORY'),
  filterList: {
    update: actionCreator<filterConditionState[]>('FILTERLIST_UPDATE'),
  },
  updateNotificationStatus: actionCreator<{ screenId: string; messageType: string; messageText?: string }>('UPDATE_NOTIFICATION_STATUS'),
  refreshNotificationStatus: actionCreator<string>('REFRESH_NOTIFICATION_STATUS'),
  updateLoadingStatus: actionCreator.async<
    LoadingType, // params
    CommonResult | undefined, // result
    {} // error
  >('UPDATE_LOADING_STATUS'),
  refreshLoadingStatus: actionCreator<LoadingType>('REFRESH_LOADING_STATUS'),
  updateSorryMessage: actionCreator<SorryMessageState>('UPDATE_SORRY_MESSAGE'),
  fetchMasterInfo: actionCreator<MasterInfoState>('FETCH_MASTER_INFO'),
  updateErrMessage: {
    errorDetail: actionCreator<ErrorParameter>('UPDATE_SORRY_MESSAGE_RESULT'),
    messageDisplayMethodList: actionCreator<Array<MessageDisplayMethodInfo>>('UPDATE_SORRY_MESSAGE_MST'),
  },
  devConsole: {
    init: actionCreator<void>('DEV_CONSOLE_INIT'),
    configure: actionCreator<DevConsoleConfig>('DEV_CONSOLE_CONFIGURE'),
    output: actionCreator<string>('DEV_CONSOLE_OUTPUT'),
    devConsoleModalOpen: actionCreator<void>('DEV_CONSOLE_MODAL_OPEN'),
    devConsoleModalClose: actionCreator<void>('DEV_CONSOLE_MODAL_CLOSE'),
  },
  /** 来店予約情報ストアのアクション */
  visitReservationInfo: {
    init: actionCreator<void>('INIT_VISIT_RESERVATION_INFO'),
    updateVisitReservationInfo: actionCreator<VisitReservationInfoState>('UPDATE_VISIT_RESERVATION_INFO'),
    updateStoreList: actionCreator<Array<VisitReservationStoreInfo>>('UPDATE_VISIT_RESERVATION_STORE_LIST'),
    updateGetSummaryApiRequest: actionCreator<GetVisitSummaryApiRequest>('UPDATE_VISIT_RESERVATION_GET_SUMMARY_API_REQUEST'),
    updateSummaryInfo: actionCreator<VisitReservationSummaryInfo>('UPDATE_VISIT_RESERVATION_SUMMARY_INFO'),
    updateListInfo: actionCreator<VisitReservationListInfo>('UPDATE_VISIT_RESERVATION_LIST_INFO'),
  },
  /** サマリー画面用 顧客全情報取得アクション*/
  fetchCustomerInfoAll: {
    init: actionCreator<void>('INIT_CUSTOMER_INFO_ALL'),
    fetch: actionCreator<CustomerInfoAllState>('FETCH_CUSTOMER_INFO_ALL'),
  },
  updateCustomerListSearchCondition: {
    init: actionCreator<void>('CUSTOMER_LIST_SEARCH_CONDITION_INIT'),
    changeSortKey: actionCreator<string>('CUSTOMER_LIST_SEARCH_CONDITION_CHANGE_SORT_KEY'),
    changeCurrentPage: actionCreator<number>('CUSTOMER_LIST_SEARCH_CONDITION_CHANGE_CURRENT_PAGE'),
    changeFilterState: actionCreator<SearchConditionState>('CUSTOMER_LIST_SEARCH_CONDITION_CHANGE_FILTER_STATE'),
  },
};

// action creator <payload truyen vao>

export const modalConfirmActions = {
  trigglerModal: actionCreator<ModalConfirmState>('TRIGGER_MODAL'),
  closeModal: actionCreator('CLOSE_MODAL'),
  handleLoading: actionCreator<boolean>('HANDLE_LOADING'),
};

// 店舗フィルタ用アクション/
export const storeFilterActions = {
  applyCheckboxFilter: actionCreator<FilterItem>('APPLY_CHECKBOX_FILTER'),
  activeFilter: actionCreator<FilterItem>('ACTIVE_FILTER'),
  deleteErr: actionCreator<string>('DELETE_ERR'),
  resetErr: actionCreator('RESET_ERR'),
  getFilterSetting: {
    start: actionCreator('GET_FILTER_SETTING_START'),
    end: actionCreator<FilterItem[]>('GET_FILTER_SETTING_END'),
    fail: actionCreator<ResultMessageDto[]>('GET_FILTER_SETTING_FAIL'),
  },
  createFilterSetting: {
    start: actionCreator('CREATE_FILTER_SETTING_START'),
    end: actionCreator('CREATE_FILTER_SETTING_END'),
    fail: actionCreator<ResultMessageDto[]>('CREATE_FILTER_SETTING_FAIL'),
  },
  updateFilterSetting: {
    start: actionCreator('UPDATE_FILTER_SETTING_START'),
    end: actionCreator('UPDATE_FILTER_SETTING_END'),
    fail: actionCreator<ResultMessageDto[]>('UPDATE_FILTER_SETTING_FAIL'),
    exist: actionCreator<FilterItem>('UPDATE_FILTER_SETTING_EXIST'),
  },
  deleteFilter: {
    start: actionCreator('DELETE_FILTER_START'),
    end: actionCreator<FilterItem>('DELETE_FILTER_END'),
    fail: actionCreator<ResultMessageDto[]>('DELETE_FILTER_FAIL'),
  },
  draftFilter: {
    create: actionCreator('DRAFT_FILTER_CREATE'), // add filter name. filter setting
    update: actionCreator<FilterItem>('DRAFT_FILTER_UPDATE'), // update filter name. filter setting
    updateOrder: actionCreator<FilterItem[]>('DRAFT_FILTER_UPDATE_ORDER'), // update filter name. filter setting
    rollBack: actionCreator('ROLLBACK_FILTER_UPDATE'), // update filter name. filter setting
    cloneCheckbox: actionCreator('CLONE_CHECKBOX'), // clone checkbox
  },
};
